import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Card, CardContent, Typography, Box, Button } from '@mui/material';
import { Description, People, Assignment, CheckCircle, Cancel, HowToReg, RateReview } from '@mui/icons-material';
import { dashboardAPI } from '../../services/api';

const StatCard = ({ icon, label, value, color }) => (
  <Card>
    <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: `${color}15` }}>
        {React.cloneElement(icon, { sx: { color, fontSize: 28 } })}
      </Box>
      <Box>
        <Typography variant="h4" sx={{ fontWeight: 700, lineHeight: 1 }}>{value}</Typography>
        <Typography variant="body2" color="text.secondary">{label}</Typography>
      </Box>
    </CardContent>
  </Card>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    dashboardAPI.stats().then((r) => setStats(r.data.data)).catch(() => {});
  }, []);

  if (!stats) return null;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Dashboard</Typography>
        <Button variant="contained" onClick={() => navigate('/admin/forms')}>
          Manage Forms
        </Button>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<Description />} label="Total Applications" value={stats.total_applications} color="#2980b9" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<RateReview />} label="Pending Reviews" value={stats.pending_reviews} color="#f39c12" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<Assignment />} label="Completed Reviews" value={stats.completed_reviews} color="#27ae60" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<People />} label="Active Reviewers" value={stats.active_reviewers} color="#8e44ad" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<CheckCircle />} label="Accepted Scholars" value={stats.accepted_scholars} color="#27ae60" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<Cancel />} label="Rejected" value={stats.rejected_scholars} color="#c0392b" />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard icon={<HowToReg />} label="Registrations" value={stats.total_registrations} color="#2c3e50" />
        </Grid>
      </Grid>
    </Box>
  );
}
